<template>
  <div>
    <form class="" onsubmit="return false;">
      <div class="mb-3">
        <input placeholder="手机号" name="mobile" required="" maxlength="11" autocomplete="off" type="input" class="form-control-lg form-control" v-model="info.mobile">
        <div class="invalid-feedback"></div>
      </div>

      <!-- 新增图形验证码区域 -->
      <div class="mb-3">
        <div class="captcha-container">
          <div class="captcha-input">
            <input placeholder="图形验证码" class="form-control-lg form-control" v-model="captchaInput">
          </div>
          <div class="captcha-img" @click="refreshCaptcha">
            <img :src="captchaImgUrl" v-if="captchaImgUrl" alt="验证码" />
            <span v-else>加载中</span>
          </div>
          <div class="captcha-refresh" @click="refreshCaptcha">
            🔄
          </div>
        </div>
      </div>

      <div class="mb-3">
        <div class="input-group">
          <input placeholder="短信验证码" name="code" v-model="info.code" maxlength="4" required="" type="text" class="form-control-lg form-control">
          <button :disabled="sendBtn" type="button" class="btn-lg btn btn-outline-secondary" style="min-width: 6.5rem;">
            <span @click="getCode">{{ codeText }}</span>
          </button>
          <div class="invalid-feedback"></div>
        </div>
      </div>

      <div class="text-secondary mb-3" v-if="!isBing" style="font-size: 97%">新手机号将自动注册</div>
      <div class="d-grid">
        <button class="sflex-center btn btn-primary btn-lg" @click="login"> {{ butText }} </button>
      </div>
    </form>
  </div>
</template>

<script>
import verifyRange from '@/components/verifyRange';
import {
  codeLogin,
  getIdentifyCode,
  WxBindAccount,
  getCaptchaImage   // 新增图形验证码接口
} from '@/api/common';
import utils from '@/assets/js/utils';
import {
  mapActions
} from 'vuex';

export default {
  name: "MobileLogin",
  data() {
    return {
      info: {
        mobile: '',
        code: ''
      },
      timer: null,
      codeText: '获取验证码',
      autoHeight: 0,
      sendBtn: false,
      // 图形验证码相关
      captchaInput: '',
      captchaKey: '',
      captchaImgUrl: '',
    };
  },
  props: {
    isBing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    butText() {
      return this.isBing ? '完成' : '登录';
    }
  },
  mounted() {
    // 页面加载时获取图形验证码
    this.refreshCaptcha();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    ...mapActions(['getCommunal']),

    /**
     * 获取图形验证码
     */
    async refreshCaptcha() {
      try {
        const res = await getCaptchaImage();
        if (res.status === 200 && res.data) {
          this.captchaImgUrl = res.data.imgUrl;
          this.captchaKey = res.data.key;
          // 每次刷新清空用户输入
          this.captchaInput = '';
        } else {
          console.error('获取图形验证码失败');
        }
      } catch (error) {
        console.error('获取图形验证码异常', error);
      }
    },

    async getCode() {
      // 倒计时中不可重复点击
      if (this.timer) return;

      const { mobile } = this.info;
      if (!mobile) {
        this.$message('请输入您的手机号');
        return;
      }
      if (!/^1[0123456789]\d{9}$/.test(mobile)) {
        this.$message('手机号码有误');
        return;
      }

      // 校验图形验证码
      if (!this.captchaInput) {
        this.$message('请输入图形验证码');
        return;
      }
      if (!this.captchaKey) {
        this.$message('图形验证码无效，请刷新重试');
        await this.refreshCaptcha();
        return;
      }

      // 禁用发送按钮
      this.sendBtn = true;

      const obj = {
        type: '1',
        mobile: mobile,
        captchaCode: this.captchaInput,
        captchaKey: this.captchaKey
      };

      try {
        const { status, message } = await getIdentifyCode(obj);
        if (status !== 200) {
          // 失败时刷新验证码，恢复按钮
          await this.refreshCaptcha();
          this.sendBtn = false;
          // 可根据需要提示 message
          // this.$message.error(message || '获取验证码失败，请重试');
          return;
        }

        // 成功：开始倒计时，并刷新图形验证码
        this.countDown();
        await this.refreshCaptcha();
      } catch (error) {
        console.error('获取验证码异常', error);
        await this.refreshCaptcha();
        this.sendBtn = false;
      }
    },

    countDown() {
      const TIME_COUNT = 60;
      let _time_count = 60;
      if (!this.timer) {
        this.sendBtn = true;
        this.codeText = '已发送' + _time_count + 's';
        this.timer = setInterval(() => {
          if (_time_count > 0 && _time_count <= TIME_COUNT) {
            this.codeText = '已发送' + _time_count-- + 's';
          } else {
            this.sendBtn = false;
            this.codeText = '重新获取';
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },

    async login() {
      const { mobile, code } = this.info;
      if (!mobile) {
        this.$message('请输入您的手机号');
        return;
      }
      if (!/^1[0123456789]\d{9}$/.test(mobile)) {
        this.$message('手机号码有误');
        return;
      }
      if (!code) {
        this.$message('请输入您的手机验证码');
        return;
      }

      if (this.isBing) {
        this.bingUser();
        return;
      }

      const obj = {
        account: mobile,
        code: code
      };
      const { data, status } = await codeLogin(obj);
      if (status !== 200) return;
      utils.setCookie('X-Access-Token', data.user_access_token.token, 7);
      this.getCommunal();
      this.$router.push('./order-list');
    },

    async bingUser() {
      const WxUserInfo = utils.getSession('WxUserInfo');
      if (!WxUserInfo) {
        this.$message('请返回登录重新登录');
        return;
      }

      const obj = {
        account: this.info.mobile,
        code: this.info.code,
        WxUserInfo: WxUserInfo
      };
      const { data, status } = await WxBindAccount(obj);
      if (status !== 200) return;
      utils.setCookie('X-Access-Token', data.user_access_token.token, 7);
      this.getCommunal();
      this.$router.push('/order-list');
    }
  },
  components: {
    verifyRange
  }
}
</script>

<style scoped>
/* 图形验证码区域布局（仿 PhoneLogin 的弹性布局） */
.captcha-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.captcha-input {
  flex: 1;
}
.captcha-img {
  width: 100px;
  height: calc(1.5em + 0.75rem + 2px); /* 与 input 高度保持一致 */
  background-color: #f5f5f5;
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.captcha-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.captcha-img span {
  font-size: 12px;
  color: #999;
}
.captcha-refresh {
  width: 36px;
  text-align: center;
  cursor: pointer;
  font-size: 20px;
  color: #ff8e1c;
  transition: opacity 0.2s;
}
.captcha-refresh:hover {
  opacity: 0.8;
}

/* 保持原有样式兼容 */
.form-control-lg {
  font-size: 97% !important;
}
.btn-group-lg > .btn,
.btn-lg {
  font-size: 97% !important;
}
</style>